export default __webpack_public_path__ + "static/14-fabrics-850a3078a5416932cef64eca9e25267e.jpeg";